<script setup lang="ts">
import { NConfigProvider, NMessageProvider, NSpin } from 'naive-ui'
import { darkTheme } from 'naive-ui'
import { useSessionStore } from './stores/session'
import { storeToRefs } from 'pinia'
import { useRefreshOnVisible } from './composables/useRefreshOnVisible'
import { useDisplayDensity } from './composables/useDisplayDensity'
import SignInForm from './views/SignInForm.vue'

const session = useSessionStore()
const { checked, currentUser } = storeToRefs(session)

// Re-sync the current user when the tab regains visibility so state
// another device may have mutated (notably last_seen_log_at)
// doesn't stay stale. No-op while signed out.
useRefreshOnVisible(() => {
  if (currentUser.value) void session.fetchCurrentUser()
})

// Mirror the signed-in user's density preference onto <html> so every
// view that opts into density-conditional CSS picks it up automatically.
useDisplayDensity()

// Naive UI's darkTheme `primaryColor` already matches our brand token
// `--color-brand-primary` in @theme (both #63e2b7), so we don't need
// `theme-overrides` to bridge the two. If a future palette change
// diverges them, add a static override here that reads from a shared
// `theme/tokens.ts` module rather than re-introducing a runtime
// `getComputedStyle` read.
</script>

<template>
  <NConfigProvider :theme="darkTheme">
    <NMessageProvider>
      <div v-if="!checked" class="flex items-center justify-center h-screen">
        <NSpin size="large" />
      </div>
      <SignInForm v-else-if="!currentUser" />
      <RouterView v-else />
    </NMessageProvider>
  </NConfigProvider>
</template>
